import comp from "./ViewerComponent";
export default comp;
